import { menuList, login, memberInfo, logout, memberRoles, memberPage  } from '@/api/index'
import { backMenuList, identityQuery } from '@/api/user'
import { traverseTree, objArrayCompare, flatTreeData } from '@/utils/index'
import { setToken, removeToken, getToken } from '@/utils/auth'
import { fetchRobotConfig } from '@/api/common'

const state = {
  token: getToken(),
  isflash: true,
  menus: [],
  name: '',
  depts: [],
  userId: '',
  userCode: '',
  mobile: '',
  userInfo: {},
  roles: [],
  companys: [],
  fMenus: [],
  mMenus: [],
  cMenus: [],
  avatar: '',
  identity: [],
  lastRow: !localStorage.getItem('lastRow') ? {} : JSON.parse(localStorage.getItem('lastRow')),
  parentRows: !localStorage.getItem('parentRows') ? [] : JSON.parse(localStorage.getItem('parentRows')),
  robotConfig: {}
}
const mutations = {
  SET_TOKEN: (state, token) => {
    setToken(token)
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_DEPTS: (state, depts) => {
    state.depts = depts
  },
  SET_MOBILE: (state, mobile) => {
    state.mobile = mobile
  },
  SET_USERCODE: (state, userCode) => {
    state.userCode = userCode
  },
  SET_USERID: (state, userId) => {
    state.userId = userId
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_USER_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_USER_COMPANYS: (state, companys) => {
    state.companys = companys
  },
  SET_FALSH: (state, isflash) => {
    state.isflash = isflash
  },
  SET_MENUS: (state, menus) => {
    state.menus = menus
  },
  SET_MENUS_F: (state, fMenus) => {
    state.fMenus = fMenus
  },
  SET_MENUS_M: (state, mMenus) => {
    state.mMenus = mMenus
  },
  SET_MENUS_C: (state, cMenus) => {
    state.cMenus = cMenus
  },
  SET_IDENTITY: (state, identity) => {
    state.identity = identity
  },
  SET_LASTROW: (state, lastRow) => {
    state.lastRow = lastRow
    localStorage.setItem('lastRow', JSON.stringify(lastRow))
  },
  SET_PARENTROWS: (state, parentRows) => {
    state.parentRows = parentRows
    localStorage.setItem('parentRows', JSON.stringify(parentRows))
  },
  SET_ROBOT_CONFIG: (state, robotConfig) => {
    state.robotConfig = robotConfig
  }
}
const actions = {
  getMenus({ commit, state }) {
    return new Promise((resolve, reject) => {
      menuList().then(response => {
        const { data } = response
        let menus = (data || []).sort(objArrayCompare)
        traverseTree(menus)
        commit('SET_MENUS', menus)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取身份
  getIdentity({ commit, state }) {
    return new Promise((resolve, reject) => {
      identityQuery().then(response => {
        const { data } = response
        commit('SET_IDENTITY', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user login
  handleLogin({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      login( userInfo ).then(res => {
        const { data } = res
        commit('SET_TOKEN', data.access_token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      memberInfo().then(response => {
        const { data } = response
        if (!data) {
          reject('Verification failed, please log in again.')
        }
        const { depts, nickName, phone, code, id, avatar } = data
        commit('SET_DEPTS', depts)
        commit('SET_NAME', nickName)
        commit('SET_MOBILE', phone)
        commit('SET_USERCODE', code)
        commit('SET_USERID', id)
        commit('SET_AVATAR', avatar)
        commit('SET_USER_INFO', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getRoles({ commit, state }) {
    return new Promise((resolve, reject) => {
      memberRoles().then(response => {
        const { data } = response
        commit('SET_USER_ROLES', data)
        // commit('SET_USER_ROLES', [{}])
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getCompanys({ commit, state }) {
    return new Promise((resolve, reject) => {
      memberPage(state.userId).then(response => {
        const { data } = response
        let list = (data || []).filter(item => item.status == 2)
        commit('SET_USER_COMPANYS', data || [])
        commit('SET_USER_ROLES', list)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_DEPTS', [])
      commit('SET_NAME', '')
      commit('SET_AVATAR', '')
      commit('SET_MENUS_F', [])
      commit('SET_MENUS_C', [])
      commit('SET_MENUS_M', [])
      removeToken()
      resolve()
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_DEPTS', [])
        commit('SET_NAME', '')
        commit('SET_MENUS_F', [])
        commit('SET_MENUS_C', [])
        commit('SET_MENUS_M', [])
        removeToken()
        // dispatch('tagsView/delAllViews', null, { root: true })
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get menu info
  getMenusBack({ commit, state }) {
    return new Promise((resolve, reject) => {
      backMenuList().then(response => {
        const { data } = response
        const arr = flatTreeData(data)
        let cMenus = [],
            mMenus = [],
            fMenus = [];
        arr.map(item => {
          if(item.menuType == 'M') {
            mMenus.push(item)
          } else if(item.menuType == 'C') {
            cMenus.push(item)
          } else if(item.menuType == 'F') {
            fMenus.push(item.perms)
          }
        })
        commit('SET_MENUS_F', fMenus)
        commit('SET_MENUS_C', cMenus)
        commit('SET_MENUS_M', mMenus)
        resolve(arr)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getRobotConfig({ commit }, params) {
    return new Promise((resolve, reject) => {
      console.log('获取机器人配置')
      fetchRobotConfig(params).then(response => {
        const { data } = response
        console.log(data)
        commit('SET_ROBOT_CONFIG', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
